import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./css/ErrorPage.module.css";

function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const ErrorPage = ({ title: propTitle, message: propMessage, code: propCode, retryUrl: propRetryUrl }) => {
    const query = useQuery();
    const navigate = useNavigate();

    const code = propCode || query.get("code");
    const title = propTitle || query.get("title") || "Something went wrong";
    const message = propMessage || query.get("message") || "An unexpected error occurred.";
    const retryUrl = propRetryUrl || query.get("retry") || "/dashboard";

    const handleRetry = () => {
        if (retryUrl === "BACK") {
            navigate(-1);
        } else {
            navigate(retryUrl);
        }
    };

    const handleGoHome = () => navigate("/dashboard");

    return (
        <div className={styles.errorPageRoot}>
            <div className={styles.errorCard}>

                <div className={styles.errorIcon}>⚠️</div>

                {code && <div className={styles.errorCode}>Error code: {code}</div>}

                <h1 className={styles.errorTitle}>{title}</h1>

                <p className={styles.errorMessage}>{message}</p>

                <div className={styles.errorActions}>
                    <button className={styles.buttonPrimary} onClick={handleRetry}>
                        Try again
                    </button>

                    <button className={styles.buttonSecondary} onClick={handleGoHome}>
                        Go to Dashboard
                    </button>
                </div>

            </div>
        </div>
    );
};

export default ErrorPage;
